<style lang="stylus">
    .line-set {
        position: relative;
        .full {
            width: 50px;
            height: 100%;
            margin: 0 auto;
        }
        .full-preview {
            // margin-left: 5px;
            // margin: 0 !important;
        }
        .rotate {
            transform: rotate(180deg);
        }
        .svgArrow {
            z-index: -1;
            position: absolute;
            top: 0;
            left: 0;
        }
        .dir-downs {
            padding: 7px;
            border: unset !important;
            border-radius: 6px;
            box-shadow: 0 0 9px #d9d9d9;
        }
        .dashitem-down {
            display: flex;
            padding: 0 6px;
            &.active {
                background: var(--bg-color-right-panel-item-dropbox-item-downs-select-item);
            }
        }

        .line-arrow-item {
            justify-content: space-between;
            align-items center
            .line-switch {
                width 24px;
                height 24px;
                cursor pointer
                display flex
                align-items center
                justify-content center
                svg {
                    width: 16px;
                    height 16px;
                    color var(--svg-color-primary)
                }
            }
            .item-dropbox {
                position: relative;
                width 90px;
                border-radius 4px;

                &.line-begin, &.line-end {

                    .item-preview {
                        pointer-events: unset;
                        position relative
                        .arrow-type {
                            position absolute
                            top -12px;
                            height 40px;
                            width  50px;
                        }
                        .ios-arrow {
                            width: 8px;
                            height: 8px;
                            position: absolute;
                            pointer-events: none;
                            top: 50%;
                            right: 2px;
                            color: var(--svg-color-primary);
                            transform: translateY(-50%);
                        }
                    }
                    .item-downs  {
                        padding: 16px 0 10px 16px;
                        height 360px
                        width 216px !important;
                        overflow hidden
                        border none;
                        border-radius 8px;
                        box-shadow: var(--box-shadow-color-box)
                        .line-title {
                            line-height 16px;
                            margin-bottom 12px;
                            text-indent 0;
                        }
                        .line-size {
                            padding-right 16px;
                            .ivu-slider {
                                .ivu-slider-wrap {
                                    margin-left: auto;
                                    width :100%;
                                    .ivu-slider-stop {
                                        // background-color: #424242;
                                    }
                                }
                            }
                        }
                        .line {
                            margin 16px 16px 16px 0;
                            border-top: 1px solid var(--border-color-box-8);
                        }
                        .line-type-wrapper {
                            height calc(100% - 74px)
                            overflow-y auto;
                            display block;
                            padding-right 16px;
                            .line-type-content{
                                display: grid;
                                grid-template-columns: repeat(4, 1fr);
                                grid-gap: 8px;
                            }
                            .item-down {
                                width 40px;
                                height 40px;
                                border-radius 6px;
                                position relative
                                &:hover, &.active {
                                    background-color transparent;
                                }
                                &.active {
                                    .border {
                                        border: 2px solid var(--themeColor)
                                    }
                                }
                                &:hover {
                                    .border {
                                        border-color: var(--themeColor)
                                    }
                                }

                                .arrowtype {
                                    width: 34px;
                                    height 40px;
                                    position absolute
                                    top 0;
                                    left 5px;
                                    color var(--svg-color-gray-42)
                                }
                                .border {
                                    width: 40px;
                                    height 40px;
                                    position absolute
                                    top 0;
                                    left 0;
                                    border-radius 6px;
                                    border: 1px solid var(--border-color-box-8)
                                }
                            }
                        }
                    }
                }

                &.line-begin  {
                    .item-preview .arrow-type {
                        left -1px;
                    }
                    .item-downs  {
                        right: auto;
                        .line-type-wrapper .item-down .arrowtype {
                            left 0;
                        }
                    }
                }
                // &.line-end {
                //     .item-preview .arrow-type {
                //         }
                // }
            }
        }

        .line-style-item {
            flex-direction: column;
            align-items:normal;
            height: auto;
            margin-bottom 12px
            &.is-en {

                .right {
                    border-radius: 6px;
                    border: 1px solid var(--border-color-box-8);
                    padding 2px;
                    gap 3px;
                    .quickstyle-svgIcon {
                        flex: 1
                        width 72px
                        padding 1px 25px ;
                        border none;
                        &.active {
                            border-radius 4px;
                            background: var(--bg-color-right-panel-item-dropbox-item-downs-select-item);
                        }
                        .quickstyle-imgbox {
                            flex-direction: column
                            .item-icon {
                                margin-right 0
                                // margin-bottom 4px;
                            }
                            .item-text {
                                display none
                            }
                        }
                    }
                }
            }
            .left {
                margin-bottom: 12px;
                position:static;
            }
            .right {
                display: flex;
                gap 9px;

            }
            .quickstyle-svgIcon {
                flex: 1
                padding: 4px 0;
                border-radius: 6px;
                border: 1px solid var(--border-color-box-8);
                &.active {
                    background: var(--bg-color-right-panel-item-dropbox-item-downs-select-item);
                }
                &:not(.active):hover {
                    background-color $main-hovercolor;
                }
                .quickstyle-imgbox {
                    display :flex;
                    justify-content: center;
                    align-items: center;

                    .item-icon {
                        color: var(--svg-color-primary);
                        height: 24px;
                        width: 24px;
                        margin-right 4px;
                    }
                    .item-text {
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 16px;
                        text-align: left;
                    }
                }
                // &:not(.active):hover {
                //     background: $ft-hover;
                // }
                // &.active {
                //     background: $ft-active;
                // }
            }
        }

        .line-color-item {
            &.disabled {
                .item-dropbox {
                    background-color transparent !important
                    .item-preview {
                        background-color var(--bg-color-ivu-input-number-input-disabled)!important;
                    }
                }
            }
            .item-dropbox {
                padding 2px;
            }
            .item-preview {
                border-radius 2px;
                border: 1px solid var(--color-black-8) !important;
                background-clip: border-box !important;
            }
        }
        .line-type-item {
            .item-dropbox .ios-arrow {
                right: 5px !important;
            }
            .item-downs {
                padding: 6px;
                border-radius: 8px;
                background-color: $navigation-modal-bgcolor
                box-shadow $common-box-shadow
                box-sizing border-box;
                border: none;
                .item-down {
                    height: 24px;
                    border-radius: 6px;
                    padding: 5px 0
                    display flex;
                    align-items center
                    svg {
                        height 18px;
                    }
                    &:hover {
                        background-color: $main-hovercolor
                    }
                }
            }
        }
        .line-jumpstyle-item {
            .ivu-select {
                width: 80px;
                margin-left: auto;
            }
        }

        .line-size-item {
            margin-bottom 12px
        }


        .line-alpha-item {
            margin-bottom: 16px;
            &.is-last {
                margin-bottom 0;
            }
            .colorSet-item-title {
                height: 24px;
                line-height: 24px;
            }
            .colorSet-slider-box {
                display: flex;
                align-items: center;
                .ivu-slider {
                    flex: 1;
                    height: 24px;
                    margin-right: 32px;
                    .ivu-slider-wrap {
                        margin: 10px 0;
                    }
                }
            }
            .ivu-input-number {
                border-radius: 4px;
            }
        }
        .line-animation-item {
            .switch-set {
                margin-bottom 16px;
                &.disabled {
                    .switch-title .title {
                        color: #bebebe;
                    }
                }
                &.hide-set {
                    margin-bottom:12px;
                }
                .switch-title {
                    display flex;
                    justify-content space-between;
                    align-items center
                    margin-bottom 12px;
                    height 24px;
                }
                .switch-default {
                    .switch-box {
                        white-space nowrap
                        .ivu-checkbox {
                            margin-right 4px
                            &:not(.ivu-checkbox-checked) {
                                .ivu-checkbox-inner {
                                    background-color var(--bg-color-tertiary)
                                }
                            }
                        }
                    }
                }
            }
            .ivu-select {
                width: 80px;
                margin-left: auto;
            }
            .show-set {
                &.disabled {
                    .show-title {
                        color: #bebebe;
                    }
                }
                .show-title {
                    color var(--text-color-primary)
                    margin-bottom 16px
                }
                .label-box-radio {
                    height 44px;
                    .ivu-radio-wrapper {
                        height 16px;
                        line-height 16px;
                        display: block;
                        .ivu-radio {
                            margin-right 4px
                        }
                        &:first-child {
                            margin-bottom 12px
                        }
                    }

                }
            }
        }
        .begindown,
        .enddown,
        .bsizedown,
        .esizedown {
            display: flex;
            align-items: center;
            justify-content: center;
            svg,
            span {
                margin: 0;
            }
            // svg {
            //     width: 36px;
            // }
            &.active {
                background: var(--bg-color-right-panel-item-dropbox-item-downs-select-item);
            }
        }
        .mask {
            z-index: 1;
            position: absolute;
            top: 0;
            left: -8px;
            bottom: 0;
            right: 0;
            background-color: rgba(255, 255, 255, 0);
            &.colorValid {
                top: 24px;
            }
        }
    }
    //
</style>
<template>
    <div class="line-set">
        <!-- 起始箭头 -->
        <div class="rPanel-item line-arrow-item" v-if="showLineSomeSet">
            <div class="item-dropbox border-hover line-begin" v-click-outside="closeBeginTypes">
                <div class="item-preview" @click="toggleType($event, 'Begin')" v-tippy="{ content: $t('LineSet.beginType'), placement: 'top' }">
                    <iconSymbol class="full full-preview arrow-type" :name="activeBeginTypeUrl()" />
                    <iconSymbol class="ios-arrow" name="right-panel-select-down-arrow" />
                </div>
                <div class="item-downs" ref="BeginRef" v-show="showBeginType">
                    <div class="line-title">{{ $t("arrowSize") }}</div>
                    <div class="line-size">
                        <LineSlider ref="BeginSlider" v-model="beginSize" :step="1" :max="7" :min="1" @on-change="changeBeginSize()"></LineSlider>
                    </div>
                    <div class="line"></div>
                    <ScrollView class="line-type-wrapper">
                        <div class="line-type-content">
                            <div
                                class="item-down begindown"
                                v-for="n in 50"
                                :class="{ active: activeBeginType + 1 == n }"
                                :key="n"
                                @click.stop="setBeginType(n - 1)"
                            >
                                <iconSymbol class="full arrowtype" :name="activeBeginTypeUrl(n - 1)" />
                                <div class="border"></div>
                            </div>
                        </div>
                    </ScrollView>
                </div>
            </div>
            <div class="line-switch" @click="switchArrow">
                <iconSymbol name="connector-switch" draggable="false" @dragstart.native.prevent />
            </div>
            <div class="item-dropbox border-hover line-end" v-click-outside="closeEndTypes">
                <div class="item-preview" @click="toggleType($event, 'End')" v-tippy="{ content: $t('LineSet.endType'), placement: 'top' }">
                    <iconSymbol class="full rotate full-preview arrow-type" :name="activeEndTypeUrl()" />
                    <iconSymbol class="ios-arrow" name="right-panel-select-down-arrow" />
                </div>
                <div class="item-downs" ref="EndRef" v-show="showEndType">
                    <div class="line-title">{{ $t("arrowSize") }}</div>
                    <div class="line-size">
                        <LineSlider ref="EndSlider" v-model="endSize" :step="1" :max="7" :min="1" @on-change="changeEndSize()"></LineSlider>
                    </div>
                    <div class="line"></div>
                    <ScrollView class="line-type-wrapper">
                        <div class="line-type-content">
                            <div
                                class="item-down enddown"
                                v-for="n in 50"
                                :class="{ active: activeEndType + 1 == n }"
                                :key="n"
                                @click.stop="setEndType(n - 1)"
                            >
                                <iconSymbol class="full rotate arrowtype" :name="activeEndTypeUrl(n - 1)" />
                                <div class="border"></div>
                            </div>
                        </div>
                    </ScrollView>
                </div>
            </div>
        </div>
        <!-- 连接线样式 -->
        <div class="rPanel-item line-style-item" v-if="showLineSomeSet" :class="{ 'is-en': lang !== 'zh' }">
            <span class="left">{{ $t("lineStyle") }}</span>
            <div class="right">
                <div
                    class="quickstyle-svgIcon"
                    :class="{ active: item.id == conType }"
                    v-for="item in list"
                    :key="item.id"
                    @click="ftSetConLineType(item.value)"
                >
                    <div class="quickstyle-imgbox" v-tippy="{ placement: 'bottom' }" :content="$t(item.text)">
                        <iconSymbol class="item-icon" :name="item.icon" @dragstart.native.prevent />
                        <span class="item-text">{{ $t(item.text) }}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 颜色 -->
        <div class="rPanel-item line-color-item" :class="{ disabled: !isSelect }">
            <span class="left">{{ $t("LineSet.Color") }}</span>
            <div class="item-dropbox" style="width: 80px" @click="showPalette">
                <div class="item-preview" :style="{ backgroundColor: color }"></div>
            </div>
        </div>
        <!-- 线型 -->
        <div class="rPanel-item line-type-item" :class="{ disabled: isDisabled }">
            <span class="left">{{ $t("LineSet.dashType") }}</span>
            <div class="item-dropbox border-hover" v-click-outside="closeDashTypes" style="width: 80px" @click="toggleType($event, 'Dash')">
                <div class="item-preview">
                    <svg class="full">
                        <iconSymbol :name="displayDashTypeUrl(activeDashType - 1)" />
                    </svg>
                    <!-- <span v-text="dashTypeText(activeDashType - 0 - 1)"></span> -->
                </div>
                <iconSymbol class="ios-arrow" name="right-panel-select-down-arrow" />
                <div class="item-downs" style="width: 80px" v-show="showDashType">
                    <div
                        class="item-down dashitem-down"
                        :class="{ active: activeDashType == n }"
                        v-for="n in 23"
                        :key="n"
                        @click.stop="setTypes(n, 'Dash')"
                    >
                        <svg class="full">
                            <iconSymbol :name="activeDashTypeUrl(n - 1)" />
                        </svg>
                        <!-- <span v-text="dashTypeText(n - 1)"></span> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- 粗细 -->
        <div class="rPanel-item line-size-item" :class="{ disabled: isDisabled }">
            <span class="left">{{ $t("LineSet.width") }}</span>
            <InputNumber
                class="input-num"
                :max="100"
                :min="0.25"
                :disabled="isDisabled"
                :step="0.25"
                v-model="width"
                style="width: 80px"
                :active-change="false"
                :formatter="(value) => `${value.toFixed(2)} pt`"
                :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                @on-focus="editLocker('focus', 'inputLocker')"
                @on-blur="
                    editLocker('blur', 'inputLocker', () => {
                        changeWidth();
                    })
                "
                @on-change="
                    editLocker('edit', 'inputLocker', () => {
                        changeWidth();
                    })
                "
                @keyup.enter.native="iviewInputBlur($event)"
            ></InputNumber>
        </div>

        <!-- 圆角 -->
        <div class="rPanel-item line-round-item" v-if="showLineSomeSet">
            <span class="left">{{ $t("LineSet.roundSize") }}</span>
            <InputNumber
                style="width: 80px"
                class="input-num"
                :max="100"
                :min="0"
                :step="1"
                v-model="RSize"
                :active-change="false"
                :formatter="(value) => `${value} mm`"
                :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                @on-focus="editLocker('focus', 'inputLocker')"
                @on-blur="
                    editLocker('blur', 'inputLocker', () => {
                        changeRound();
                    })
                "
                @on-change="
                    editLocker('edit', 'inputLocker', () => {
                        changeRound();
                    })
                "
                @keyup.enter.native="iviewInputBlur($event)"
            ></InputNumber>
        </div>
        <!-- 跳线样式 -->
        <div class="rPanel-item line-jumpstyle-item" v-if="showLineSomeSet">
            <span class="left">{{ $t("LineSet.jumpLineStyle") }}</span>
            <i-select :transfer="true" size="small" :value="activeJPMText" @on-change="setTypes($event, 'jumpMode')">
                <i-option v-for="item in 3" :value="JPMText(item - 1)" :key="JPMText(item - 1)">
                    {{ $t(`LineSet.${JPMText(item - 1)}`) }}
                </i-option>
            </i-select>
        </div>

        <!-- 透明度 -->
        <div class="colorSet-item line-alpha-item" :class="{ disabled: isDisabled, 'is-last': !showLineAnimateSet }">
            <div class="colorSet-item-title">{{ $t("LineSet.transparency") }}</div>
            <div class="colorSet-slider-box">
                <Slider
                    :max="100"
                    :min="0"
                    v-model="alphaVal"
                    @on-input="changeAlpha()"
                    :disabled="isDisabled"
                    @mousedown.native="modifyTintPreRedo()"
                    @mouseup.native="modifyTintRedo()"
                ></Slider>
                <InputNumber
                    class="input-num"
                    :max="100"
                    :min="0"
                    style="width: 80px"
                    size="small"
                    v-model="alphaVal"
                    :disabled="isDisabled"
                    :active-change="false"
                    :formatter="(value) => `${value}%`"
                    :parser="(value) => value.replace('%', '')"
                    @on-focus="editLocker('focus', 'inputLocker')"
                    @on-blur="
                        editLocker('blur', 'inputLocker', () => {
                            changeAlpha();
                            handleChangeSet();
                        })
                    "
                    @on-change="
                        editLocker('edit', 'inputLocker', () => {
                            changeAlpha();
                            handleChangeSet();
                        })
                    "
                    @keyup.enter.native="iviewInputBlur($event)"
                ></InputNumber>
            </div>
        </div>
        <!-- 流向动画 -->
        <div class="line-animation-item" v-if="showLineAnimateSet">
            <div class="set-box switch-set" :class="{ 'hide-set': !showLineAnimate, disabled: isDisabled }">
                <div class="switch-title">
                    <span class="title">{{ $t("openanimate") }}</span>
                    <i-switch :value="showLineAnimate" size="small" @on-change="changeShowLineAnimate" ref="switchRef" :disabled="isDisabled" />
                </div>
                <div class="switch-default" v-if="showLineAnimate">
                    <Checkbox
                        class="switch-box"
                        ref="openRef"
                        :value="autoShowConnectAnimation"
                        @on-change="changeAutoShowConnectAnimation"
                        :disabled="isDisabled"
                    >
                        {{ $t("deafultopen") }}
                    </Checkbox>
                </div>
            </div>
            <template v-if="showLineAnimate">
                <div class="set-box property-set">
                    <div class="rPanel-item" :class="{ disabled: isDisabled }">
                        <div class="left">{{ $t("anistyle") }}</div>
                        <i-select class="selecter" v-model="animateStyle" size="small" :disabled="isDisabled">
                            <i-option :value="0">{{ $t("aniarrow") }}</i-option>
                            <i-option :value="1">{{ $t("anicircle") }}</i-option>
                        </i-select>
                    </div>
                    <div class="rPanel-item" :class="{ disabled: isDisabled }">
                        <div class="left">{{ $t("anispeed") }}</div>
                        <i-select class="selecter" v-model="animateSpeed" size="small" :disabled="isDisabled" :placement="densityPlacement">
                            <i-option :value="0">{{ $t("anifast") }}</i-option>
                            <i-option :value="1">{{ $t("animedium") }}</i-option>
                            <i-option :value="2">{{ $t("anislow") }}</i-option>
                        </i-select>
                    </div>
                    <div class="rPanel-item" :class="{ disabled: isDisabled }">
                        <div class="left">{{ $t("anidensity") }}</div>
                        <i-select class="selecter" v-model="animateDensity" size="small" :disabled="isDisabled" :placement="densityPlacement">
                            <i-option :value="0">{{ $t("anilarge") }}</i-option>
                            <i-option :value="1">{{ $t("animedium") }}</i-option>
                            <i-option :value="2">{{ $t("anifew") }}</i-option>
                        </i-select>
                    </div>
                    <div class="rPanel-item line-color-item" :class="{ disabled: isDisabled }">
                        <div class="left">{{ $t("anicolor") }}</div>
                        <div class="item-dropbox" style="width: 80px" @click="showLineAnimationPalette">
                            <div class="item-preview" :style="{ backgroundColor: animateColor }"></div>
                        </div>
                    </div>
                    <div class="rPanel-item" :class="{ disabled: isDisabled }">
                        <div class="left">{{ $t("anidirection") }}</div>
                        <i-select class="selecter" v-model="animateDirection" size="small" :disabled="isDisabled" :placement="directionPlacement">
                            <i-option :value="0">{{ $t("aniforward") }}</i-option>
                            <i-option :value="1">{{ $t("anireverse") }}</i-option>
                        </i-select>
                    </div>
                </div>
                <div class="set-box show-set" :class="{ disabled: isDisabled }">
                    <div class="show-title">{{ $t("showtime") }}</div>
                    <RadioGroup class="label-box-radio" v-model="animateShowTime">
                        <Radio class="label-box-radioitem" :key="$t('openshow')" :label="0" :disabled="isDisabled">
                            <span>{{ $t("openshow") }}</span>
                        </Radio>
                        <Radio class="label-box-radioitem" :key="$t('clickshow')" :label="1" :disabled="isDisabled">
                            <span>{{ $t("clickshow") }}</span>
                        </Radio>
                    </RadioGroup>
                </div>
            </template>
        </div>
        <div class="mask" :class="{ colorValid: isSelect }" v-show="isDisabled"></div>
    </div>
</template>

<script lang="ts">
    declare var UnitUtil: any;
    declare var eFmtSetFlag: any;
    enum CapType {
        Flat,
        Square,
        Round,
    }
    enum ArrowSize {
        "Very Small" = 2,
        Small = 3,
        Middle = 4,
        Large = 6,
        "Extra Large" = 9,
        Jumbo = 12,
        Colossal = 14,
    }

    enum JumpMode {
        None,
        Horizontal,
        Vertical,
    }

    import { Component, Prop, Vue, Inject, Watch } from "vue-property-decorator";
    import LineSlider from "./LineSlider.vue";
    import ScrollView from "@/public/components/ScrollView/ScrollView.vue";
    import { AnimeOPe } from "@/app/types";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            LineSlider,
            ScrollView,
        },
    })
    export default class LineSet extends Vue {
        @Inject()
        ["iviewInputBlur"];

        @Prop({ default: false }) isDisabled: boolean;
        @Prop({ default: null }) from!: number;
        @Prop({ default: "#ffffff" }) fromColor!: string;
        @Prop({ default: null }) fromPaintType!: number; // 1,solid,2,gradient,3,pattern,4,texture
        @Prop({ default: null }) index!: number;

        inputLocker: boolean = false;
        showDashType: boolean = false;
        showCapType: boolean = false;
        showRPType: boolean = false; // Rounding presets
        showBeginType: boolean = false;
        showBSType: boolean = false;
        showEndType: boolean = false;
        showESType: boolean = false;
        RPPreview = {
            backgroundImage: "url(" + require("@/app/assets/img/dock/2_round.png") + ")",
        };
        dirL: number = 20; //dir长度 /px;
        dirP: number = 7; //dir的padding /px;

        beginSize: number = 2;
        endSize: number = 2;

        // 连接线样式
        list = [
            {
                id: 2,
                value: 1,
                icon: "new-connector-line1",
                text: "rightAngle",
            },
            {
                id: 1,
                value: 2,
                icon: "new-connector-line2",
                text: "curve",
            },
            {
                id: 0,
                value: 3,
                icon: "new-connector-line3",
                text: "straight",
            },
        ];

        showFunVipTip(data) {
            this.$bus.$emit("showLineFunVipTip", data);
        }

        get autoShowConnectAnimation() {
            return this.$store.state.ui.customDefaultAutoSetConnectorAnimation;
        }

        changeAutoShowConnectAnimation(val) {
            if (!this.vip && val) {
                this.$nextTick(() => {
                    this.$store.commit("setStatus", {
                        type: "customDefaultAutoSetConnectorAnimation",
                        data: !val,
                    });
                    (this.$refs.openRef as any).updateModel();
                    this.showFunVipTip("lineAnimationLimitCount");
                });
                return;
            }
            this.$bus.$emit("changePageConnectLineAnimation", {
                type: "autoSetConnectorAnimation",
                data: val,
            });
            if (!this.showLineAnimate && val) {
                this.setAnimate(AnimeOPe.AnimeShow, Number(val));
            }

            if (!val) {
                this.sensors.track("styleSet", {
                    Catalogues: "rightMenu Bar",
                    style_tab: "flowAnimitionl",
                });
            }
        }

        get animateShowTime() {
            return this.$store.state.ui.customDefaultConnectAnimateShowTime;
        }

        set animateShowTime(val) {
            this.$bus.$emit("changePageConnectLineAnimation", {
                type: "connectorAnimationShowTime",
                data: val,
            });
            let _view = window["_view"];
            _view?.updateItemAnim();
        }

        get showLineAnimate() {
            return this.$store.state.shape.lineAnimateData.showAnime;
        }
        get isMultiSel() {
            return this.$store.state.shape.isMultiSel;
        }
        get multiSelCount() {
            return this.$store.state.shape.multiSelCount;
        }
        get densityPlacement() {
            if (this.lang === "de" || this.lang === "fr") {
                return "bottom-end";
            }
            return "bottom";
        }
        get directionPlacement() {
            if (this.lang === "fr" || this.lang === "pt" || this.lang === "it" || this.lang === "pt") {
                return "bottom-end";
            }
            return "bottom";
        }

        changeShowLineAnimate(v) {
            if (!this.vip && v) {
                let _view = window["_view"];
                let count = _view.getAnimationCount();
                if (this.isMultiSel) {
                    count += this.multiSelCount;
                } else {
                    count += 1;
                }
                if (count > 2) {
                    this.showFunVipTip("lineAnimationLimitCount");
                    this.$nextTick(() => {
                        (this.$refs.switchRef as any).currentValue = false;
                    });
                    return;
                }
            }
            this.setAnimate(AnimeOPe.AnimeShow, Number(v));
        }

        get animateStyle() {
            return this.$store.state.shape.lineAnimateData.animeStyle;
        }

        set animateStyle(v) {
            this.setAnimate(AnimeOPe.AnimeStyle, v);
        }

        get animateSpeed() {
            return this.$store.state.shape.lineAnimateData.animeSpeed;
        }

        set animateSpeed(v) {
            this.setAnimate(AnimeOPe.AnimeSpeed, v);
        }

        get animateDensity() {
            return this.$store.state.shape.lineAnimateData.animeDensity;
        }

        set animateDensity(v) {
            this.setAnimate(AnimeOPe.AnimeDensity, v);
        }

        get animateColor() {
            return this.$store.state.shape.lineAnimateData.animeColor;
        }

        get animateDirection() {
            return this.$store.state.shape.lineAnimateData.animeDirection;
        }

        set animateDirection(v) {
            this.setAnimate(AnimeOPe.AnimeDirction, v);
        }

        showLineAnimationPalette(e): void {
            let payload = {
                type: this.fmtType.lineAnimate,
                index: 0,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type: "lineAnimateRigthPanel" });
                this.$store.commit("setStatus", {
                    type: "isStopPropagation",
                    data: true,
                });
            });
        }

        setAnimate(type: number, value: number | boolean) {
            let _view = window["_view"];
            if (!_view || !this.isSelect) return;
            let toStoreKey = "";
            if (!this.vip) {
                const count = _view.getAnimationCount();
                if (count === 2 && !this.showLineAnimate) {
                    this.showFunVipTip("lineAnimationLimitCount");
                    return;
                }
            }

            _view.animeOperation(type, value);
            switch (type) {
                case AnimeOPe.AnimeShow:
                    value = !!value;
                    toStoreKey = "showAnime";
                    break;
                case AnimeOPe.AnimeStyle:
                    toStoreKey = "animeStyle";
                    break;
                case AnimeOPe.AnimeSpeed:
                    toStoreKey = "animeSpeed";
                    break;
                case AnimeOPe.AnimeDensity:
                    toStoreKey = "animeDensity";
                    break;
                case AnimeOPe.AnimeDirction:
                    toStoreKey = "animeDirection";
                    break;
            }
            if (toStoreKey) {
                this.$store.commit("setLineAnimateData", {
                    type: toStoreKey,
                    data: value,
                });
            }
            if (!this.showLineAnimate && toStoreKey !== "showAnime") {
                // 不开动画的时候设置，就是改默认设置
                this.$bus.$emit("changePageConnectLineAnimation", {
                    type: toStoreKey,
                    data: value,
                });
            }
            this.sensors.track("styleSet", {
                Catalogues: "rightMenu Bar",
                style_tab: "flowAnimitionl",
            });
        }

        ftSetConLineType(value) {
            window["_view"].cnntorOperation(value);
            this.sensors.track("editConnector", {
                Catalogues: "shortcutToolbar",
                content: "LineStyle",
            });
            this.handleChangeSet();
        }

        tempData = null;

        modifyTintPreRedo() {
            if (this.isDisabled) return;
            this.tempData = this.alphaVal;
            window["_view"].addFormatPreUndoAct(this.from);
        }
        modifyTintRedo() {
            if (this.isDisabled) return;
            let flag = false;
            flag = this.tempData != this.alphaVal;
            window["_view"].addFormatUndoAct(flag);
            this.tempData = false;
            this.handleChangeSet();
        }

        changeAlpha() {
            if (this.isDisabled) return;
            this.$nextTick(() => {
                console.log(this.alphaVal);
                window["_view"]._tool.endEdit();
                let view = window["_view"];
                if (this.fromPaintType === 4) {
                    view.setFmt(
                        {
                            _alpha: Math.round(255 - (this.alphaVal / 100) * 255),
                        },
                        eFmtSetFlag.FillTextureAlp,
                        false
                    );
                } else {
                    view.setFmt(
                        {
                            _paintType: this.fromPaintType,
                            _index: this.index,
                            _alpha: parseFloat((1 - this.alphaVal / 100).toFixed(2)),
                        },
                        eFmtSetFlag.ColorChangeAlpha | this.from,
                        false
                    );
                }
            });
        }

        showPalette(e): void {
            window["_view"]._tool.endEdit();
            let node = e.target;
            let payload = {
                type: this.from,
                index: this.index,
            };
            this.$store.commit("setColor", payload);
            let type = this.from == this.fmtType.fill ? "RightColorFill" : this.from == this.fmtType.line ? "RightColorLine" : "RightColor";
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type });
            });
        }

        @Watch("showLineSomeSet")
        watchShowLineSomeSet(nv) {
            if (!nv) {
                this.showBeginType = false;
                this.showEndType = false;
            }
        }

        get showLineSomeSet() {
            return this.isLine && !this.isDisabled;
        }

        get showLineAnimateSet() {
            return this.isLine || this.containLine;
        }

        get containLine() {
            if (this.isMultiSel) {
                return this.$store.state.shape.containLine;
            }
            return false;
        }

        get isLine() {
            return this.$store.state.shape.isLine;
        }

        get fmtType() {
            return this.$store.state.ui.fmtType;
        }

        get color() {
            if (this.from === null) {
                return this.fromColor;
            } else if (this.from === this.fmtType.fill) {
                return this.$store.state.shape.fillFmt.colors[this.index];
            } else if (this.from === this.fmtType.line) {
                return this.$store.state.shape.lineFmt.colors?.[this.index];
            } else if (this.from === this.fmtType.shadow) {
                return this.$store.state.shape.shadowFmt.color;
            }
        }

        get alphaVal() {
            if (this.from === null) {
                return 0;
            } else if (this.from === this.fmtType.fill) {
                if (this.fromPaintType === 4) {
                    return Math.round(((255 - this.$store.state.shape.fillFmt.textureAlpha) / 255) * 100);
                } else {
                    return Math.round((1 - this.$store.state.shape.fillFmt.alphas[this.index]) * 100);
                }
            } else if (this.from === this.fmtType.line && this.$store.state.shape.lineFmt.alphas?.length) {
                return Math.round((1 - this.$store.state.shape.lineFmt.alphas[this.index]) * 100);
            } else if (this.from === this.fmtType.shadow) {
                return Math.round((1 - this.$store.state.shape.shadowFmt.alpha) * 100);
            }
            return 0;
        }
        set alphaVal(v: any) {
            let payload =
                this.fromPaintType === 4
                    ? {
                          type: "textureAlpha",
                          data: Math.round(255 - (v / 100) * 255),
                      }
                    : {
                          type: "alphas",
                          data: 1 - v / 100,
                          index: this.index,
                      };
            if (this.from === null) {
            } else if (this.from === this.fmtType.fill) {
                if (this.fromPaintType === 4) {
                    this.$store.commit("setFillFmtData", payload);
                } else {
                    this.$store.commit("setFillColorData", payload);
                }
            } else if (this.from === this.fmtType.line) {
                this.$store.commit("setLineColorData", payload);
            } else if (this.from === this.fmtType.shadow) {
                payload.type = "alpha";
                this.$store.commit("setShadowFmtData", payload);
            }
        }

        JPMText(n) {
            return JumpMode[n];
        }

        get activeJPMode() {
            return this.$store.state.page.jumpMode;
        }

        get activeJPMText() {
            return JumpMode[this.activeJPMode];
        }

        editLocker(type, lock, fn?) {
            if (this.isDisabled) return;
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }
        changeWidth() {
            let v = this.width;
            console.log(v);
            window["_view"]._tool.endEdit();
            let view = window["_view"];
            let payload = {
                _width: v,
            };
            view.setFmt(payload, eFmtSetFlag.LineWidth);
            this.handleChangeSet();
        }
        changeRound() {
            let v = this.RSize;
            window["_view"]._tool.endEdit();
            let view = window["_view"];
            let payload = {
                _round: v,
            };
            view.setFmt(payload, eFmtSetFlag.LineRound);
            this.handleChangeSet();
        }
        toggleType(e: MouseEvent, type: string) {
            if (this.isDisabled) return;
            this["show" + type + "Type"] = !this["show" + type + "Type"];
            window["_view"]._tool.endEdit();
            if (type === "Begin" || type === "End") {
                if (this["show" + type + "Type"]) {
                    let target = e.target as HTMLElement;
                    let maxH = window.innerHeight - e.pageY - (target.clientHeight - e.offsetY) - this.$store.state.ui.sceneBottom - 32;

                    this.$nextTick(() => {
                        let downs = this.$refs[`${type}Ref`] as HTMLElement;
                        downs.style.maxHeight = (maxH <= 60 ? 60 : maxH) + "px";
                        let curSlider = this.$refs[`${type}Slider`] as any;
                        curSlider.$refs?.minTooltip?.updatePopper();
                    });
                }
            }
        }

        @Watch("activeBSType", { immediate: true })
        watchActiveBSType(nv, ov) {
            if (nv <= 4) {
                this.beginSize = nv - 1;
            } else if (nv === 14) {
                this.beginSize = 7;
            } else {
                this.beginSize = (nv + 6) / 3;
            }
        }

        @Watch("activeESType", { immediate: true })
        watchActiveESType(nv, ov) {
            if (nv <= 4) {
                this.endSize = nv - 1;
            } else if (nv === 14) {
                this.endSize = 7;
            } else {
                this.endSize = (nv + 6) / 3;
            }
        }

        changeBeginSize() {
            this.$nextTick(() => {
                let n = this.beginSize;
                let view = window["_view"];
                let newSize = n;
                if (n <= 3) {
                    newSize = n + 1;
                } else if (n <= 6) {
                    newSize = 3 * n - 6;
                } else {
                    newSize = 14;
                }
                view.setFmt(
                    {
                        _size: newSize,
                    },
                    eFmtSetFlag.LineBASize
                );
                this.handleChangeSet();
                this.activeBSType = newSize;
            });
        }
        changeEndSize() {
            this.$nextTick(() => {
                let n = this.endSize;
                let view = window["_view"];
                let newSize = n;
                if (n <= 3) {
                    newSize = n + 1;
                } else if (n <= 6) {
                    newSize = 3 * n - 6;
                } else {
                    newSize = 14;
                }
                view.setFmt(
                    {
                        _size: newSize,
                    },
                    eFmtSetFlag.LineEASize
                );
                this.handleChangeSet();
                this.activeESType = newSize;
            });
        }

        switchArrow() {
            let a = this.activeBeginType,
                b = this.activeEndType;
            window["_view"].setFmts(
                [
                    {
                        args: {
                            _type: b,
                        },
                        mask: eFmtSetFlag.LineBAType,
                    },
                    {
                        args: {
                            _type: a,
                        },
                        mask: eFmtSetFlag.LineEAType,
                    },
                ],
                eFmtSetFlag.LineArrows
            );
            this.sensors.track("editConnector", {
                Catalogues: "shortcutToolbar",
                content: "switchLineType",
            });
            this.handleChangeSet();
        }

        get customSet() {
            return this.$store.state.ui.defaultConnectorType == 1;
        }

        setTypes(n, type: string) {
            console.log(n);
            window["_view"]._tool.endEdit();
            let view = window["_view"];
            this["active" + type + "Type"] = n == 1 ? n - 1 : n;

            if (type === "Dash") {
                view.setFmt(
                    {
                        _dash: this["active" + type + "Type"],
                    },
                    eFmtSetFlag.LineDash
                );
            } else if (type === "Cap") {
                let strLiteral = n - 1 === CapType.Flat ? "butt" : n - 1 === CapType.Square ? "square" : "round";
                view.setFmt(
                    {
                        _cap: strLiteral,
                    },
                    eFmtSetFlag.LineCap
                );
            } else if (type === "RP") {
                let rsize;
                if (n === 1) {
                    rsize = 0;
                } else if (n <= 6) {
                    rsize = n;
                } else if (n === 7) {
                    rsize = 8;
                } else {
                    rsize = 10;
                }
                this.RSize = rsize;
                view.setFmt(
                    {
                        _round: rsize,
                    },
                    eFmtSetFlag.LineRound
                );
            } else if (type === "Begin") {
                view.setFmt(
                    {
                        _type: n - 1,
                    },
                    eFmtSetFlag.LineBAType
                );
            } else if (type === "End") {
                view.setFmt(
                    {
                        _type: n - 1,
                    },
                    eFmtSetFlag.LineEAType
                );
            } else if (type === "jumpMode") {
                n = JumpMode[n];
                if (this.customSet) {
                    this.$bus.$emit("changePageConnectLine", {
                        type: "jumpMode",
                        data: n,
                    });
                }
                view.lineJumpsModeChanged(n);
                view.setPageStatus();
            }
            this.$nextTick(() => {
                this["show" + type + "Type"] = false;
            });
            this.handleChangeSet();
        }
        setBeginType(index) {
            let view = window["_view"];
            view.setFmt(
                {
                    _type: index,
                },
                eFmtSetFlag.LineBAType
            );
            this.handleChangeSet();
            // this.showBeginType = false;
        }
        setEndType(index) {
            let view = window["_view"];
            view.setFmt(
                {
                    _type: index,
                },
                eFmtSetFlag.LineEAType
            );
            // this.showEndType = false;
        }

        closeDashTypes() {
            this.showDashType = false;
        }
        activeDashTypeUrl(index: number) {
            return "dt" + index;
        }
        displayDashTypeUrl(index: number) {
            index = index < 0 ? 0 : index;
            return "dt" + index;
        }
        dashTypeText(index: number = this.activeDashType) {
            index < 0 && (index = 0);
            return index < 10 ? "0" + index : index;
        }

        closeCapTypes() {
            this.showCapType = false;
        }
        capTypeText(index: CapType = this.activeCapType) {
            return CapType[index];
        }

        closeRP() {
            this.showRPType = false;
        }
        RPSize(index: number) {
            let size: number = 0;
            if (index === 0) {
                size = 0;
            } else if (index >= 1 && index < 6) {
                size = index + 1;
            } else if (index === 6) {
                size = 8;
            } else if (index === 7) {
                size = 10;
            }
            return index;
        }
        RPStyle(index: number) {
            let size = this.RPSize(index);
            let pxSize = UnitUtil.unitToPixel(size, 9);
            return {
                border: "1px solid black",
                borderTopRightRadius: pxSize + "px",
                background: "white",
                borderLeftWidth: 0,
                borderBottomWidth: 0,
            };
        }
        closeBeginTypes() {
            this.showBeginType = false;
        }
        activeBeginTypeUrl(index: number = this.activeBeginType) {
            return "arrow-" + index;
        }
        beginTypeText(index: number = this.activeBeginType) {
            return index < 10 ? "0" + index : index;
        }

        closeBeginSizes() {
            this.showBSType = false;
        }
        activeBSText() {
            return ArrowSize[this.activeBSType];
        }
        activeESText() {
            return ArrowSize[this.activeESType];
        }
        BSText(index: ArrowSize) {
            let type;
            if (index <= 3) {
                type = index + 1;
            } else if (index <= 6) {
                type = 3 * index - 6;
            } else {
                type = 14;
            }
            return ArrowSize[type];
        }
        closeEndSizes() {
            this.showESType = false;
        }
        ESText(index: ArrowSize) {
            let type;
            if (index <= 3) {
                type = index + 1;
            } else if (index <= 6) {
                type = 3 * index - 6;
            } else {
                type = 14;
            }
            return ArrowSize[type];
        }
        closeEndTypes() {
            this.showEndType = false;
        }
        activeEndTypeUrl(index: number = this.activeEndType) {
            return "arrow-" + index;
        }
        endTypeText(index: number = this.activeEndType) {
            return index < 10 ? "0" + index : index;
        }

        handleChangeSet() {
            this.$emit("changeSet");
        }

        get shapeConLine() {
            return this.$store.state.shape.conLineType;
        }

        get isSelect() {
            return !!this.$store.state.shape.isActived;
        }

        get conType() {
            if (this.isSelect && this.shapeConLine != null) return this.shapeConLine;
        }

        get width() {
            return this.$store.state.shape.lineFmt.width;
        }
        set width(v) {
            let payload = {
                type: "width",
                data: v,
            };
            this.$store.commit("setLineFmtData", payload);
        }
        get activeDashType() {
            return this.$store.state.shape.lineFmt.dash;
        }
        set activeDashType(v) {
            let payload = {
                type: "dash",
                data: v,
            };
            this.$store.commit("setLineFmtData", payload);
        }
        get activeCapType() {
            return this.$store.state.shape.lineFmt.cap;
        }
        set activeCapType(v) {
            let payload = {
                type: "cap",
                data: v,
            };
            this.$store.commit("setLineFmtData", payload);
        }
        get RSize() {
            return this.$store.state.shape.lineFmt.round;
        }
        set RSize(v) {
            let payload = {
                type: "round",
                data: v,
            };
            this.$store.commit("setLineFmtData", payload);
        }
        get activeRPType() {
            if (this.RSize === 0) {
                return 0;
            } else if (this.RSize >= 2 && this.RSize <= 6 && this.RSize % 1 === 0) {
                return parseInt(this.RSize) - 1;
            } else if (this.RSize === 8) {
                return 6;
            } else if (this.RSize === 10) {
                return 7;
            }
            return null;
        }
        set activeRPType(v: any) {}
        get activeBeginType() {
            return this.$store.state.shape.lineFmt.startArrowId;
        }
        set activeBeginType(v) {
            let payload = {
                type: "startArrowId",
                data: v,
            };
            this.$store.commit("setLineFmtData", payload);
        }
        get activeEndType() {
            return this.$store.state.shape.lineFmt.endArrowId;
        }
        set activeEndType(v) {
            let payload = {
                type: "endArrowId",
                data: v,
            };
            this.$store.commit("setLineFmtData", payload);
        }
        get activeBSType() {
            return this.$store.state.shape.lineFmt.startArrowSize;
        }
        set activeBSType(v) {
            let payload = {
                type: "startArrowSize",
                data: v,
            };
            this.$store.commit("setLineFmtData", payload);
        }
        get activeESType() {
            return this.$store.state.shape.lineFmt.endArrowSize;
        }
        set activeESType(v) {
            let payload = {
                type: "endArrowSize",
                data: v,
            };
            this.$store.commit("setLineFmtData", payload);
        }

        get dirWH() {
            return {
                width: this.dirL + "px",
                height: this.dirL + "px",
                padding: this.dirP + "px",
            };
        }
        get dirsWCss() {
            let w: number;
            let h: number;
            w = this.dirsWidth / 2;
            h = 2 * this.dirFullW;
            return {
                width: w + "px",
                height: h + "px",
            };
        }
        get dirFullW() {
            return this.dirL + 2 * this.dirP;
        }
        get dirsWidth() {
            return this.dirNum * this.dirFullW + 14;
        }
        get dirNum() {
            return 8;
        }
    }
</script>
<i18n>
{
  "zh": {
    "Flat": "扁平",
    "Square": "方形",
    "Round": "圆形",
    "Very Small": "非常小",
    "Small": "小",
    "Middle": "中",
    "Large": "大",
    "Extra Large": "特大",
    "Jumbo": "巨大",
    "Colossal": "超大",
    "arrowSize": "箭头大小",
    "lineStyle": "样式",
    "straight": "直线",
    "curve": "曲线",
    "rightAngle": "直角",
    "LineSet": {
      "width": "粗细",
      "dashType": "虚线",
      "Color": "颜色",
      "transparency": "透明度",
      "jumpLineStyle": "跳线样式",
      "None": "无",
      "Horizontal": "显示在水平线条上",
      "Vertical": "显示在垂直线条上",
      "capType": "线头样式",
      "roundPreset": "预设圆角",
      "roundSize": "圆角",
      "beginType": "起点",
      "beginSize": "起点大小",
      "endType": "终点",
      "endSize": "终点大小"
    },
    "openanimate": "开启流向动画",
    "lineanimate": "流向动画",
    "deafultopen": "默认开启",
    "styleset": "样式设置",
    "anistyle": "流动样式",
    "anispeed": "流动速度",
    "anidensity": "流动密度",
    "anicolor": "动画颜色",
    "anidirection": "动画方向",
    "aniarrow": "箭头",
    "anicircle": "圆点",
    "anifast": "快速",
    "animedium": "中等",
    "anislow": "慢速",
    "anilarge": "密集",
    "anifew": "稀疏",
    "aniforward": "正向",
    "anireverse": "反向",
    "showtime": "显示时机",
    "openshow": "开启即显示",
    "clickshow": "点击图形显示"
  },
  "en": {
    "LineSet": {
      "width": "Thickness",
      "dashType": "Line Type",
      "Color": "Color",
      "transparency": "Transparency",
      "jumpLineStyle": "Dotted Line",
      "None": "None",
      "Horizontal": "Horizontal",
      "Vertical": "Vertical",
      "capType": "Cap type",
      "roundPreset": "Rounding presets",
      "roundSize": "Corner Radius",
      "beginType": "Begin type",
      "beginSize": "Begin size",
      "endType": "End type",
      "endSize": "End size"
    },
    "openanimate": "Enable Flow Animation",
    "lineanimate": "Flow Animation",
    "deafultopen": "Enabled by default",
    "styleset": "Style Settings",
    "anistyle": "Flow style",
    "anispeed": "Flow speed",
    "anidensity": "Flow density",
    "anicolor": "Flow color",
    "anidirection": "Flow direction",
    "aniarrow": "Arrows",
    "anicircle": "Beads",
    "anifast": "Fast",
    "animedium": "Medium",
    "anislow": "Slow",
    "anilarge": "Dense",
    "anifew": "Sparse",
    "aniforward": "Forward",
    "anireverse": "Reverse",
    "showtime": "Flow Timing",
    "openshow": "Display when enabled",
    "clickshow": "Display when clicking shapes",
    "Very Small": "Very Small",
    "Small": "Small",
    "Middle": "Middle",
    "Large": "Large",
    "Extra Large": "Extra Large",
    "Jumbo": "Jumbo",
    "Colossal": "Colossal",
    "arrowSize": "Arrow size",
    "lineStyle": "Connector type",
    "straight": "Line",
    "curve": "Curve",
    "rightAngle": "Polyline",
    "Flat": "Flat",
    "Square": "Square",
    "Round": "Round"
  },
  "fr": {
    "Flat": "Plat",
    "Square": "Carré",
    "Round": "Rond",
    "Very Small": "Très petit",
    "Small": "Petit",
    "Middle": "Moyen",
    "Large": "Grand",
    "Extra Large": "Très grande ",
    "Jumbo": "Géant",
    "Colossal": "Colossal",
    "arrowSize": "Taille de la flèche",
    "lineStyle": "Type de connecteur",
    "straight": "Ligne",
    "curve": "Courbe",
    "rightAngle": "Polyline",
    "LineSet": {
      "width": "Épaisseur",
      "dashType": "Type de ligne",
      "Color": "Couleur",
      "transparency": "Transparence",
      "jumpLineStyle": "Ligne pointillée",
      "None": "无",
    "Horizontal": "水平线",
    "Vertical": "垂直线",
      "capType": "Type de bouchon",
      "roundPreset": "Presets arrondis",
      "roundSize": "Rayon de l'angle",
      "beginType": "Type de début",
      "beginSize": "Taille de début",
      "endType": "Type de fin",
      "endSize": "Taille de fin"
    },
    "openanimate": "Activer Animation du flux",
    "lineanimate": "Animation du flux",
    "deafultopen": "Activé par défaut",
    "styleset": "Paramètres de style",
    "anistyle": "Type de flux",
    "anispeed": "Vitesse du flux ",
    "anidensity": "Densité du flux ",
    "anicolor": "Couleur du flux",
    "anidirection": "Direction du flux ",
    "aniarrow": "Flèches",
    "anicircle": "Puces",
    "anifast": "Rapide",
    "animedium": "Moyenne",
    "anislow": "Lente",
    "anilarge": "Dense",
    "anifew": "Peu dense",
    "aniforward": "Vers l'avant",
    "anireverse": "Inversion",
    "showtime": "Durée du flux",
    "openshow": "S'affiche lorsque cette option est activée",
    "clickshow": "S'affiche lorsque l'on clique sur les formes"
  },
  "de": {
    "Flat": "Flach ",
    "Square": "Quadrat",
    "Round": "Kreis",
    "Very Small": "Sehr klein",
    "Small": "Klein",
    "Middle": "Mittel",
    "Large": "Groß",
    "Extra Large": "Sehr groß",
    "Jumbo": "Riesig",
    "Colossal": "Übergroß",
    "arrowSize": "Pfeilgröße",
    "lineStyle": "Verbindertyp",
    "straight": "Linie",
    "curve": "Kurve",
    "rightAngle": "Polylinie",
    "LineSet": {
      "width": "Dicke",
      "dashType": "Linientyp",
      "Color": "Farbe",
      "transparency": "Transparent",
      "jumpLineStyle": "Punktierte Linie",
      "None": "无",
    "Horizontal": "水平线",
    "Vertical": "垂直线",
      "capType": "Kappenart",
      "roundPreset": "Rundungsvoreinstellungen",
      "roundSize": "Eckradius",
      "beginType": "Anfangsformat",
      "beginSize": "Anfangsgröße",
      "endType": "Endformat",
      "endSize": "Endgröße"
    },
    "openanimate": "Flussanimation aktivieren",
        "lineanimate": "Flüssige Animation",
        "deafultopen": "Standardmäßig aktiviert",
        "styleset": "Stileinstellungen",
        "anistyle": "Fluss-Stil",
        "anispeed": "Flussgeschwindigkeit",
        "anidensity": "Flussdichte",
        "anicolor": "Flussfarbe",
        "anidirection": "Flussrichtung",
        "aniarrow": "Pfeile",
        "anicircle": "Punkte",
        "anifast": "Schnell",
        "animedium": "Mittel",
        "anislow": "Langsam",
        "anilarge": "Dicht",
        "anifew": "Dünn besetzt",
        "aniforward": "Vor",
        "anireverse": "Zurück",
        "showtime": "Zeitpunkt des Flusses",
        "openshow": "Anzeigen, wenn aktiviert",
        "clickshow": "Anzeigen beim Klicken auf Formen"
  },
  "jp": {
    "Flat": "フラット",
    "Square": "四方形",
    "Round": "円形",
    "Very Small": "超小",
    "Small": "小",
    "Middle": "中",
    "Large": "大",
    "Extra Large": "特大",
    "Jumbo": "巨大",
    "Colossal": "超大",
    "arrowSize": "矢印サイズ",
    "lineStyle": "コネクタの種類",
    "straight": "直線",
    "curve": "曲線",
    "rightAngle": "ポリライン",
    "LineSet": {
      "width": "太さ",
      "dashType": "線種",
      "Color": "色",
      "transparency": "透明度",
      "jumpLineStyle": "点線",
      "None": "无",
    "Horizontal": "水平线",
    "Vertical": "垂直线",
      "capType": "端/角の形",
      "roundPreset": "角の丸み",
      "roundSize": "角の半径",
      "beginType": "始点",
      "beginSize": "始点のサイズ",
      "endType": "終点",
      "endSize": "終点のサイズ"
    },
    "openanimate": "フローアニメーションを有効にする",
        "lineanimate": "フローアニメーション",
        "deafultopen": "デフォルトで有効にする",
        "styleset": "スタイル設定",
        "anistyle": "フロースタイル",
        "anispeed": "フローの速さ",
        "anidensity": "フローの密度",
        "anicolor": "フローの色",
        "anidirection": "フローの方向",
        "aniarrow": "矢印",
        "anicircle": "ビーズ",
        "anifast": "速",
        "animedium": "中",
        "anislow": "遅",
        "anilarge": "密",
        "anifew": "疎",
        "aniforward": "順方向",
        "anireverse": "逆方向",
        "showtime": "フローのタイミング",
        "openshow": "有効にしたときに表示",
        "clickshow": "図形をクリックしたときに表示"
  },
  "es": {
    "Flat": "Plano",
    "Square": "Cuadrado",
    "Round": "Redondo",
    "Very Small": "Muy pequeño",
    "Small": "Pequeño",
    "Middle": "Medio",
    "Large": "Grande",
    "Extra Large": "Extra Large",
    "Jumbo": "Jumbo",
    "Colossal": "Colosal",
    "arrowSize": "Tamaño de flecha",
    "lineStyle": "Tipo de conector",
    "straight": "Línea",
    "curve": "Curva",
    "rightAngle": "Polilínea",
    "LineSet": {
      "width": "Grosor",
      "dashType": "Tipo de Línea",
      "Color": "Color",
      "transparency": "Transparencia",
      "jumpLineStyle": "Línea de puntos",
      "None": "无",
    "Horizontal": "水平线",
    "Vertical": "垂直线",
      "capType": "Tipo de gorra",
      "roundPreset": "Redondeo de preselecciones",
      "roundSize": "Radio de redondeo",
      "beginType": "Empezar a escribir",
      "beginSize": "Comenzar el tamaño",
      "endType": "Tipo de final",
      "endSize": "Tamaño final"
    },
    "openanimate": "Activar animación de flujo",
        "lineanimate": "Animación de flujos",
        "deafultopen": "Activado de forma predeterminada",
        "styleset": "Ajustes de estilo",
        "anistyle": "Estilo de flujo",
        "anispeed": "Velocidad de flujo",
        "anidensity": "Densidad de flujo",
        "anicolor": "Color del flujo",
        "anidirection": "Dirección del flujo",
        "aniarrow": "Flechas",
        "anicircle": "Cuentas",
        "anifast": "Rápida",
        "animedium": "Media",
        "anislow": "Lenta",
        "anilarge": "Denso",
        "anifew": "Escaso",
        "aniforward": "Avanzar",
        "anireverse": "Retroceder",
        "showtime": "Cadencia del flujo",
        "openshow": "Mostrar cuando está activado",
        "clickshow": "Mostrar al hacer clic en formas"
  },
  "pt": {
    "LineSet": {
      "width": "Espessura",
      "dashType": "Tipo de Linha",
      "Color": "Cor",
      "transparency": "Transparência",
      "jumpLineStyle": "Linha pontilhada",
      "None": "无",
    "Horizontal": "水平线",
    "Vertical": "垂直线",
      "capType": "Tipo de Limite",
      "roundPreset": "Predefinir Arredondamento",
      "roundSize": "Raio de canto",
      "beginType": "Tipo de Início",
      "beginSize": "Tamanho de Início",
      "endType": "Tipo de Fim",
      "endSize": "Tamanho de Fim"
    },
    "openanimate": "Habilitar animação de fluxo",
        "lineanimate": "Animação de fluxo",
        "deafultopen": "Habilitado por padrão",
        "styleset": "Configurações de estilo",
        "anistyle": "Estilo de fluxo",
        "anispeed": "Velocidade do fluxo",
        "anidensity": "Densidade do fluxo",
        "anicolor": "Cor do fluxo",
        "anidirection": "Direção do fluxo",
        "aniarrow": "Setas",
        "anicircle": "Esferas",
        "anifast": "Rápido",
        "animedium": "Médio",
        "anislow": "Lento",
        "anilarge": "Denso",
        "anifew": "Esparso",
        "aniforward": "Para a frente",
        "anireverse": "Inversa",
        "showtime": "Tempo do fluxo",
        "openshow": "Exibir quando habilitado",
        "clickshow": "Exibir ao clicar em formas",
    "Very Small": "Muito Pequeno",
    "Small": "Pequeno",
    "Middle": "Médio",
    "Large": "Grande",
    "Extra Large": "Muito Grande",
    "Jumbo": "Enorme",
    "Colossal": "Colossal",
    "arrowSize": "Tamanho da seta",
    "lineStyle": "Tipo de Conector",
    "straight": "Linha",
    "curve": "Curva",
    "rightAngle": "Polilinha",
    "Flat": "Plano",
    "Square": "Quadrado",
    "Round": "Redondo"
  },
  "it": {
    "LineSet": {
      "width": "Spessore",
      "dashType": "Tipo di linea",
      "Color": "Colore",
      "transparency": "Trasparenza",
      "jumpLineStyle": "Linea punteggiata",
      "None": "无",
    "Horizontal": "水平线",
    "Vertical": "垂直线",
      "capType": "Tipo di Estremità",
      "roundPreset": "Preset di Arrotondamento",
      "roundSize": "Raggio angolo",
      "beginType": "Tipo Parte Iniziale",
      "beginSize": "Dimensione Parte Iniziale",
      "endType": "Tipo Parte Finale",
      "endSize": "Dimensione Parte Finale"
    },
    "openanimate": "Attiva Animazione flusso",
        "lineanimate": "Animazione flusso",
        "deafultopen": "Attivato per impostazione predefinita",
        "styleset": "Impostazioni stile",
        "anistyle": "Stile flusso",
        "anispeed": "Velocità flusso",
        "anidensity": "Densità flusso",
        "anicolor": "Colore flusso",
        "anidirection": "Direzione flusso",
        "aniarrow": "Frecce",
        "anicircle": "Gocce",
        "anifast": "Veloce",
        "animedium": "Media",
        "anislow": "Lenta",
        "anilarge": "Denso",
        "anifew": "Rado",
        "aniforward": "Avanti",
        "anireverse": "Inverti",
        "showtime": "Tempo flusso",
        "openshow": "Visualizza quando attivato",
        "clickshow": "Visualizza quando si fa clic sulle forme",
    "Very Small": "Molto Piccolo",
    "Small": "Piccolo",
    "Middle": "Medio",
    "Large": "Grande",
    "Extra Large": "Molto Grande",
    "Jumbo": "Enorme",
    "Colossal": "Colossale",
    "arrowSize": "Dimensione freccia",
    "lineStyle": "Tipo di connettore",
    "straight": "Linea",
    "curve": "Curva",
    "rightAngle": "Polilinea",
    "Flat": "Piatto",
    "Square": "Quadrato",
    "Round": "Rotondo"
  },
  "tw": {
    "Flat": "扁平",
    "Square": "方形",
    "Round": "圓形",
    "Very Small": "非常小",
    "Small": "小",
    "Middle": "中",
    "Large": "大",
    "Extra Large": "特大",
    "Jumbo": "巨大",
    "Colossal": "超大",
    "arrowSize": "",
    "lineStyle": "連接線類型",
    "straight": "",
    "curve": "",
    "rightAngle": "",
    "LineSet": {
      "width": "寬度",
      "dashType": "線型",
      "Color": "顏色",
      "transparency": "透明度",
      "jumpLineStyle": "",
      "None": "无",
        "Horizontal": "水平线",
        "Vertical": "垂直线",
      "capType": "線頭樣式",
      "roundPreset": "預設圓角",
      "roundSize": "圓角大小",
      "beginType": "起點類型",
      "beginSize": "起點大小",
      "endType": "終點類型",
      "endSize": "終點大小"
    }
  }
}
</i18n>
